/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Table_LabelInputs */

const en_options_api_keys_table_label = /** @type {(inputs: Options_Api_Keys_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Keys Table`)
};

const fr_options_api_keys_table_label = /** @type {(inputs: Options_Api_Keys_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau des clés API`)
};

const de_options_api_keys_table_label = /** @type {(inputs: Options_Api_Keys_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüsseltabelle`)
};

const it_options_api_keys_table_label = /** @type {(inputs: Options_Api_Keys_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabella delle chiavi API`)
};

const ru_options_api_keys_table_label = /** @type {(inputs: Options_Api_Keys_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Таблица ключей API`)
};

const es_options_api_keys_table_label = /** @type {(inputs: Options_Api_Keys_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabla de claves API`)
};

const zh_cn2_options_api_keys_table_label = /** @type {(inputs: Options_Api_Keys_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API密钥表`)
};

const ja_options_api_keys_table_label = /** @type {(inputs: Options_Api_Keys_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIキーテーブル`)
};

const hi_options_api_keys_table_label = /** @type {(inputs: Options_Api_Keys_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एपीआई कुंजी तालिका`)
};

const pt_pt2_options_api_keys_table_label = /** @type {(inputs: Options_Api_Keys_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabela de chaves de API`)
};

/**
* | output |
* | --- |
* | "API Keys Table" |
*
* @param {Options_Api_Keys_Table_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_table_label = /** @type {((inputs?: Options_Api_Keys_Table_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Table_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_table_label(inputs)
	if (locale === "de") return de_options_api_keys_table_label(inputs)
	if (locale === "it") return it_options_api_keys_table_label(inputs)
	if (locale === "ru") return ru_options_api_keys_table_label(inputs)
	if (locale === "es") return es_options_api_keys_table_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_table_label(inputs)
	if (locale === "ja") return ja_options_api_keys_table_label(inputs)
	if (locale === "hi") return hi_options_api_keys_table_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_table_label(inputs)
	return en_options_api_keys_table_label(inputs)
});